import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

import { environment } from 'env/environment';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private static readonly COOKIE_NAME = 'kh_cookie_consent';

  private readonly document = inject(DOCUMENT);

  /** Returns true if the banner should be displayed */
  public requiresAcknowledgement(): boolean {
    const raw = this.getCookieValue(CookieConsentService.COOKIE_NAME);
    if (!raw) { return true; }

    const acknowledgedAt = new Date(raw);
    if (isNaN(acknowledgedAt.getTime())) { return true; } // malformed — safe fallback

    const expiryDate = new Date(acknowledgedAt);
    expiryDate.setDate(expiryDate.getDate() + environment.cookieConsentExpiryDays);

    return new Date() > expiryDate;
  }

  /** Persists acknowledgement with current timestamp */
  public saveAcknowledgement(): void {
    const timestamp = new Date().toISOString();
    const maxAge = environment.cookieConsentExpiryDays * 24 * 60 * 60;
    const isSecure = !environment.local && this.document.location.protocol === 'https:';

    let cookieString =
      `${CookieConsentService.COOKIE_NAME}=${encodeURIComponent(timestamp)}` +
      `; path=/` +
      `; max-age=${maxAge}` +
      `; SameSite=Lax`;

    if (isSecure) {
      cookieString += `; Secure`;
    }

    this.document.cookie = cookieString;
  }

  private getCookieValue(name: string): string | null {
    const match = this.document.cookie
      .split(';')
      .map((c) => c.trim())
      .find((c) => c.startsWith(`${name}=`));

    return match ? decodeURIComponent(match.substring(name.length + 1)) : null;
  }
}
